import React from "react"
import CautionNote from "./CautionNote"
import SiteContainer from "../../../utils/SiteContainer"

interface iCalculatorFormPanel {
  CalculatorForm?: object
  ProgressPanel?: object
}

const CalculatorSection: React.FC<iCalculatorFormPanel> = ({
  CalculatorForm,
  ProgressPanel,
}) => (
  <SiteContainer>
    <div className="py-8">
      <CautionNote />
      <div className="py-4" />
      <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">{CalculatorForm}</div>
        <div className="relative">
          <div className="lg:sticky" style={{ top: "116px" }}>
            {ProgressPanel}
          </div>
        </div>
      </section>
    </div>
  </SiteContainer>
)
export default CalculatorSection
